/*
 * @Autor: 陈钊贤
 * @Version: 1.0
 * @Date: 2019-11-18 13:17:34
 * @LastEditors: 陈钊贤
 * @Description:
 * @LastEditTime: 2021-08-19 16:18:07
 */
import { Notice } from "view-design";
import conf from "@/common/common";
import config from "@/config/config";
import { objAny } from "@/common/common-interface";
import i18n from "@/config/i18n";
const WebSocketFn: objAny = {
  webSocket: null,
  heartflag: false,
  tryTime: 0,
  timer: null,
  isClose: false,
  initSocket: function(obj: objAny) {
    const that = this;
    if (!window.WebSocket) {
      Notice.error({
        title: i18n.t("tips"),
        desc: i18n.t("nonRealNameCardManagement.notSupport")
      });
      return false;
    }
    const server = config.socketServer; // 'ws://192.168.0.73:8080/Pilot'

    that.webSocket = new window.WebSocket(server);

    // 建立连接
    that.webSocket.onopen = function(event: Event) {
      that.heartflag = true;
      this.isClose = false;
      // heart();
      obj.onopen && obj.onopen();
      that.tryTime = 0;
    };
    // 收到服务端消息
    that.webSocket.onmessage = function(msg: objAny) {
      // if (msg.data === "&") {
      // } else {
      if (conf.isJSON(msg.data)) {
        obj.onmessage(JSON.parse(msg.data));
      }
      // }
    };

    // 异常
    that.webSocket.onerror = function(event: Event) {
      that.heartflag = false;
      // console.log(obj.onerror)
      obj.onerror && obj.onerror();
    };

    // 断线重连
    that.webSocket.onclose = function() {
      if (this.isClose) {
        console.log("关闭。。。");
        this.isClose = false;
        return;
      }
      that.heartflag = false;
      // 重试10次，每次之间间隔10秒
      if (that.tryTime < 3) {
        that.timer = setTimeout(function() {
          that.webSocket = null;
          that.tryTime++;
          that.initSocket(obj);
          // console.log("  第"+that.tryTime+"次重连<br/>")
        }, 3 * 1000);
      } else {
        Notice.error({
          title: i18n.t("tips"),
          desc: i18n.t("nonRealNameCardManagement.cardConnectionFailed")
        });
        that.tryTime = 0;
        obj.onerror(10);
      }
    };
  },
  send(obj: objAny) {
    if (this.heartflag) {
      console.log(JSON.stringify(obj));
      this.webSocket.send(JSON.stringify(obj));
    }
  },
  clearTime() {
    clearTimeout(this.timer);
  },
  close() {
    console.log("关闭");
    this.isClose = true;
    // this.close();
  }
};

export default WebSocketFn;
